import { Heading, ButtonRow, Button, FormTextInput, FormManager, FormTextAreaInput } from "cai-fusion"
import { useNavigate, useParams } from "react-router-dom";

import GIFAnimationReading from "../../../../images/animation-reading-doc.gif"
import { useState, useEffect } from "react";
import { useSiftV2 } from "../../contexts/siftV2Context";

const SiftOppTypeEdit = ({isEditing = false}) => {

    const navigate = useNavigate();
    const params = useParams();
    const { currOppType, currTypeId, setCurrTypeId } = useSiftV2();

    const [formObj, setFormObj] = useState({
        "title": "",
        "description": "",
        "analysisInstructions": "",
    });

    useEffect(() => {
        if (currTypeId != params.OppTypeId) {
            setCurrTypeId(params.OppTypeId);
            document.title = "Sift V2 - Edit Opportunity Type"
        }
    }, [])

    useEffect(() => {
        if (currOppType.id && isEditing) {
            setFormObj({...currOppType});
        }
    }, [currOppType])
    
    return (
        <div className="o-page-section o-page-section l-pt-none">
            <div className="o-page-section__content-container o-page-section__content-container--fixed-width l-pt-none l-mt-neg-sm">
                <div className="l-row l-pt-sm">
                    <div className="row">
                        <div className="col-md-12">
                            <Heading size={1}>{isEditing ? "Edit" : "Create New"} Opportunity Type</Heading>
                            <p className="a-muted-text">
                                Opportunity types are a way to shaping the analysis of particular types of opportunities. 
                                This allows you to create a template that can be used to analyze opportunities of a certain type.
                            </p>
                            <div className="row">
                                <div className="col-12">
                                    <Heading size={2} className="l-mt-xs l-mb-sm">Opportunity Type Details</Heading>
                                    <div className="o-block">
                                        <FormManager formObj={formObj}>
                                            <FormTextInput 
                                                displayName="Title"
                                                fieldId="title"
                                            />
                                            <FormTextAreaInput 
                                                displayName="Description"
                                                fieldId="description"
                                                rows={3}
                                                description="Provide a brief description of the opportunity type that's displayed on the New Opportunity page."
                                            />
                                            <FormTextAreaInput 
                                                displayName="Analysis Instructions"
                                                fieldId="analysisInstructions"
                                                rows={15}
                                                description="These instructions are used to guide the analysis of the opportunity. Provide a detailed overview of the analysis that will be performed. The more detailed, the better!"
                                            />
                                        </FormManager>
                                    </div>
                                    <ButtonRow className="l-mt-sm">
                                        {/* NFI */}
                                        <Button 
                                            outline
                                            children="Cancel"
                                            onClick={() => navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/types`)}
                                        />
                                        <Button 
                                            children={isEditing ? "Save" : "Create"}
                                            onClick={() => navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/types`)}
                                        />
                                    </ButtonRow>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiftOppTypeEdit;